import { Form, Input, Tag, Button, Modal, Row, Col, message } from 'antd'
import { CopyOutlined, SearchOutlined } from '@ant-design/icons'
import { useMyContext } from 'Context/MyContextProvider'
import React, { useEffect, useState } from 'react'
import { ROW_GUTTER } from 'constants/ThemeConstant'

const CommonNumberField = ({ numbers, additionalNumbers = [], number, setNumber }) => {
    const { getNumberCount } = useMyContext()
    const [combinedAdditional, setCombinedAdditional] = useState('')
    const [modalVisible, setModalVisible] = useState(false)
    const [searchValue, setSearchValue] = useState('')

    const buildUniqueList = (value) => {
        if (!value) return ''
        const match = value.match(/\n*$/)
        const trailingNewlines = match ? match[0] : ''
        const mainContent = value.slice(0, value.length - trailingNewlines.length)

        const seen = new Set()
        const cleaned = mainContent
            .split('\n')
            .map((item) => item.trim())
            .filter(Boolean)
            .filter((item) => {
                if (seen.has(item)) return false
                seen.add(item)
                return true
            })
            .join('\n')

        return cleaned + trailingNewlines
    }

    const filteredNumbers = searchValue
        ? numbers.filter(num => String(num)?.includes(searchValue))
        : numbers

    const handleCopyAll = () => {
        navigator.clipboard.writeText(numbers.join('\n'))
        message.success('Numbers copied to clipboard!')
    }

    useEffect(() => {
        // Combine status/excel numbers with manual input for the Additional Mobile Numbers field
        const statusText = (additionalNumbers && additionalNumbers.length > 0) ? additionalNumbers.join('\n') : '';
        const manualText = number ? number : '';
        const combined = [statusText, manualText].filter(Boolean).join('\n');
        setCombinedAdditional(buildUniqueList(combined));
    }, [additionalNumbers, number]);

    const normalizeManualNumbers = (value) => {
        return value
            .replace(/\r/g, '')
            .replace(/\n+/g, '\n')
            .replace(/\s*,\s*/g, '\n')
            .replace(/[^0-9\n]/g, '');
    }

    return (
        <>
            {numbers?.length > 0 &&
                <Form.Item className='m-0' label="Mobile Number from Groups">
                    <div>
                        {numbers.slice(0, 6).map((n) => (
                            <Tag key={n} color={'magenta'}>{n}</Tag>
                        ))}
                        {numbers.length > 6 && (
                            <Button type="link" onClick={() => setModalVisible(true)}>
                                View All ({numbers.length})
                            </Button>
                        )}
                    </div>
                    <Modal
                        title={
                            <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                                <Col>Mobile Numbers from Groups</Col>
                                <Col>
                                    <Input
                                        placeholder="Search numbers"
                                        prefix={<SearchOutlined />}
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                        size="small"
                                        style={{ width: 200 }}
                                    />
                                </Col>
                            </Row>
                        }
                        open={modalVisible}
                        onCancel={() => {
                            setModalVisible(false)
                            setSearchValue('')
                        }}
                        width={860}
                        closable={false}
                        maskClosable={true}
                        footer={
                            <Row gutter={ROW_GUTTER} justify="space-between" align="middle">
                                <Col>
                                    <span style={{ color: '#6b7280', fontSize: 13 }}>
                                        Showing: <strong style={{ color: '#1890ff' }}>{filteredNumbers.length}</strong> / {numbers.length}
                                    </span>
                                </Col>
                                <Col>
                                    <Button key="copy" type="primary" size="small" icon={<CopyOutlined />} onClick={handleCopyAll}>
                                        Copy All
                                    </Button>
                                    <Button key="close" size="small" onClick={() => setModalVisible(false)} style={{ marginLeft: 8 }}>
                                        Close
                                    </Button>
                                </Col>
                            </Row>
                        }
                    >
                        <div>
                            {filteredNumbers.length > 0 ? (
                                <Row gutter={[0, 8]}>
                                    {filteredNumbers.map((num, idx) => (
                                        <Col span={3} key={idx}>
                                            <Tag
                                                onClick={() => {
                                                    navigator.clipboard.writeText(num)
                                                    message.success('Copied!')
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {num}
                                            </Tag>
                                        </Col>
                                    ))}
                                </Row>
                            ) : (
                                <div style={{ textAlign: 'center', color: '#999', padding: '20px 0' }}>
                                    No numbers found
                                </div>
                            )}
                        </div>
                    </Modal>
                </Form.Item>
            }
            <Form.Item className='m-0' label={`${numbers?.length > 0 ? 'Additional ' : ''}Mobile Numbers`} >
                <Input.TextArea
                    rows={5}
                    type="text"
                    value={combinedAdditional}
                    onChange={(e) => {
                        const newValue = normalizeManualNumbers(e.target.value);
                        // Keep manual input state in `number`; status/excel numbers remain in `additionalNumbers` (passed from parent)
                        setNumber(buildUniqueList(newValue));
                    }}
                />
                <p className='float-right'>Max 10000 Numbers | Total numbers: {getNumberCount(additionalNumbers, number)}</p>
            </Form.Item>
        </>
    )
}

export default CommonNumberField
